module.exports = __webpack_public_path__ + "static/How-to-Install-2-e1403552703261-787fd164a8ac1f5cf23cd0ec75590951.jpg";